(function() {
  if (window.__fndBundleUpsellDeferredLoaded) {
    console.log('[FND Bundle Upsell] Script already loaded, skipping duplicate init');
    return;
  }
  window.__fndBundleUpsellDeferredLoaded = true;
  console.log('[FND Bundle Upsell] Deferred script loaded');

  function log() {
    var args = Array.prototype.slice.call(arguments);
    args.unshift('[FND Bundle Upsell]');
    console.log.apply(console, args);
  }

  function formatMoney(cents, moneyFormat) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat || '{{amount}}').replace('.00', '');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function isTruthySellingPlanValue(value) {
    var normalized = (value == null ? '' : String(value)).trim().toLowerCase();
    return normalized !== '' && normalized !== '0' && normalized !== 'null' && normalized !== 'false';
  }

  function hasSubscribeAndSaveSelection(scope, productForm) {
    var root = productForm || scope || document;
    var sellingPlanInput = root.querySelector('input[name="selling_plan"]');
    if (sellingPlanInput && isTruthySellingPlanValue(sellingPlanInput.value)) {
      return true;
    }

    var checkedPaywhirlInput = root.querySelector('.paywhirl-plan-selector-group input[type="radio"]:checked');
    if (checkedPaywhirlInput && checkedPaywhirlInput.closest) {
      var checkedGroup = checkedPaywhirlInput.closest('.paywhirl-plan-selector-group');
      if (checkedGroup) {
        var checkedGroupName = checkedGroup.querySelector('.paywhirl-plan-selector-group-name');
        if (checkedGroupName && /subscribe\s*and\s*save/i.test(checkedGroupName.textContent || '')) {
          return true;
        }
      }
    }

    return false;
  }

  function initBundleUpsell(container) {
    if (!container || container.dataset.fndBundleInit === 'true') {
      if (container && container.dataset.fndBundleInit === 'true') {
        log('Container already initialized for product', container.getAttribute('data-fnd-bundle-product-id'));
      }
      return;
    }

    var productId = container.getAttribute('data-fnd-bundle-product-id');
    var productHandle = container.getAttribute('data-fnd-bundle-product-handle');
    var mainProductTitle = container.getAttribute('data-fnd-bundle-product-title') || '';
    var moneyFormat = container.getAttribute('data-fnd-bundle-money-format') || '{{amount}}';
    var redirectEnabled = container.getAttribute('data-fnd-bundle-redirect-enabled') === 'true';

    if (!productId) {
      log('Missing productId on bundle container, skipping init');
      return;
    }

    var radioName = 'fnd-bundle-' + productId;
    var bundleGroup = container.querySelectorAll('input[name="' + radioName + '"]');
    if (!bundleGroup.length) {
      log('No bundle radios found for', radioName, '- skipping init');
      return;
    }

    log('Initializing bundle for product', productId, 'with', bundleGroup.length, 'options');

    container.dataset.fndBundleInit = 'true';

    var lastChecked = null;

    bundleGroup.forEach(function(radio) {
      radio.addEventListener('click', function() {
        if (lastChecked === this) {
          this.checked = false;
          lastChecked = null;
        } else {
          lastChecked = this;
        }
      });
    });

    var scope = container.closest('[data-section-id], .product, .product--outer, .product-area') || document;

    var productForm = scope.querySelector('form[data-product-form], form[action*="/cart/add"]');
    var submitButton = null;
    if (productForm) {
      submitButton = productForm.querySelector('[data-product-submit], [data-product-card-interaction-addtocart], button[name="add"], button[type="submit"], input[type="submit"]');
    }
    if (!submitButton) {
      submitButton = scope.querySelector('[data-product-submit], [data-product-card-interaction-addtocart], button[name="add"], button[type="submit"], input[type="submit"]');
    }

    function setBundleEnabledState(isEnabled) {
      if (isEnabled) {
        container.style.display = '';
        container.removeAttribute('aria-hidden');
        delete container.dataset.fndBundleDisabledBySubscription;
      } else {
        container.style.display = 'none';
        container.setAttribute('aria-hidden', 'true');
        container.dataset.fndBundleDisabledBySubscription = 'true';
      }
    }

    function syncBundleStateFromPaywhirl() {
      var shouldDisableBundle = hasSubscribeAndSaveSelection(scope, productForm);

      if (shouldDisableBundle) {
        bundleGroup.forEach(function(radio) {
          radio.checked = false;
        });
        lastChecked = null;
      }

      setBundleEnabledState(!shouldDisableBundle);
      return shouldDisableBundle;
    }

    syncBundleStateFromPaywhirl();

    log('Resolved scope/form/button', {
      hasScope: !!scope,
      hasForm: !!productForm,
      hasSubmitButton: !!submitButton
    });

    if (productForm) {
      var isSubmittingBundle = false;

      function handleBundleAddToCart(e) {
        if (syncBundleStateFromPaywhirl()) {
          log('Subscribe and Save is selected, skipping bundle add interception');
          return false;
        }

        var selectedBundle = container.querySelector('input[name="' + radioName + '"]:checked');
        if (!selectedBundle || isSubmittingBundle) {
          if (!selectedBundle) {
            log('No selected bundle option at submit time');
          }
          if (isSubmittingBundle) {
            log('Submission already in progress, ignoring duplicate submit');
          }
          return false;
        }

        log('Intercepting add-to-cart for selected option', selectedBundle.value);

        if (e) {
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === 'function') {
            e.stopImmediatePropagation();
          }
        }

        isSubmittingBundle = true;

        var variantIds = (selectedBundle.getAttribute('data-variant-ids') || '').split(',');
        var quantityInput = null;
        if (productForm) {
          quantityInput = productForm.querySelector('.product-quantity-input, [name="quantity"]');
        }
        if (!quantityInput) {
          quantityInput = scope.querySelector('.product-quantity-input, [name="quantity"]');
        }
        var quantity = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;

        log('Preparing bundle cart payload', {
          option: selectedBundle.value,
          variantIds: variantIds,
          quantity: quantity
        });

        if (submitButton && submitButton.classList) {
          submitButton.classList.add('loading');
        }
        var spinner = submitButton ? submitButton.querySelector('.product-card-interaction-addtocart-spinner') : null;
        if (spinner) {
          spinner.style.display = 'block';
        }

        var bundleKey = 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);

        var items = variantIds.map(function(variantId, index) {
          var item = {
            id: parseInt((variantId || '').trim(), 10),
            quantity: quantity,
            properties: {}
          };

          if (index === 0) {
            item.properties._fnd_bundle = 'true';
            item.properties._fnd_bundle_key = bundleKey;
          } else {
            var discountPercent = selectedBundle.getAttribute('data-discount');
            item.properties._fnd_bundle_key = bundleKey;

            item.properties._fnd_discount = discountPercent;
            item.properties['Bundle discount'] = 'Bundled with ' + mainProductTitle;
          }

          return item;
        }).filter(function(item) {
          return !isNaN(item.id);
        });

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function(response) {
            log('cart/add.js response', { status: response.status, ok: response.ok });
            if (!response.ok) {
              throw new Error('Failed to add to cart');
            }
            return response.json();
          })
          .then(function(data) {
            log('Bundle added successfully', data);
            if (submitButton && submitButton.classList) {
              submitButton.classList.remove('loading');
            }
            if (spinner) {
              spinner.style.display = '';
            }

            document.dispatchEvent(new CustomEvent('cart:updated'));
            document.dispatchEvent(new CustomEvent('ajaxCart:updated'));

            if (typeof jQuery !== 'undefined') {
              jQuery(document).trigger('cart:updated');
              jQuery(document).trigger('ajaxCart.afterCartUpdate');
            }

            if (submitButton && submitButton.classList) {
              submitButton.classList.add('added-to-cart');
            }
            var successText = submitButton ? submitButton.querySelector('.product-card-interaction-addtocart-success') : null;
            var availableText = submitButton ? submitButton.querySelector('.product-card-interaction-addtocart-available') : null;

            if (successText) {
              if (availableText) {
                availableText.style.display = 'none';
              }
              successText.style.display = 'block';
            }

            setTimeout(function() {
              if (submitButton && submitButton.classList) {
                submitButton.classList.remove('added-to-cart');
              }
              if (successText) {
                successText.style.display = '';
              }
              if (availableText) {
                availableText.style.display = '';
              }

              if (redirectEnabled) {
                log('Redirecting to /cart after successful add');
                window.location.href = '/cart';
              }
            }, 1500);
          })
          .catch(function(error) {
            log('Bundle add failed', error);
            if (submitButton && submitButton.classList) {
              submitButton.classList.remove('loading');
            }
            if (spinner) {
              spinner.style.display = '';
            }

            var errorText = submitButton ? submitButton.querySelector('.product-card-interaction-addtocart-error') : null;
            var availableText = submitButton ? submitButton.querySelector('.product-card-interaction-addtocart-available') : null;

            if (errorText) {
              if (availableText) {
                availableText.style.display = 'none';
              }
              errorText.style.display = 'block';

              setTimeout(function() {
                errorText.style.display = '';
                if (availableText) {
                  availableText.style.display = '';
                }
              }, 3000);
            }
          })
          .finally(function() {
            isSubmittingBundle = false;
            log('Bundle submission cycle complete');
          });

        return true;
      }

      if (submitButton) {
        submitButton.addEventListener('click', function(e) {
          log('Submit button clicked');
          handleBundleAddToCart(e);
        }, true);
      }

      productForm.addEventListener('submit', function(e) {
        log('Product form submit fired');
        if (handleBundleAddToCart(e)) {
          return false;
        }
      }, true);
    } else {
      log('No product form found in scope; bundle add interception is not attached');
    }

    // Keep upsell availability in sync when PayWhirl switches between one-time and subscription.
    ['change', 'click'].forEach(function(eventName) {
      document.addEventListener(eventName, function(event) {
        var target = event && event.target;
        if (!target || !target.matches) {
          return;
        }

        if (
          target.matches('input[name="selling_plan"]') ||
          target.matches('.paywhirl-plan-selector-group input') ||
          target.matches('.paywhirl-plan-selector-group') ||
          target.matches('.paywhirl-plan-selector')
        ) {
          syncBundleStateFromPaywhirl();
        }
      }, true);
    });

    if (typeof MutationObserver !== 'undefined') {
      var paywhirlObserver = new MutationObserver(function() {
        syncBundleStateFromPaywhirl();
      });

      paywhirlObserver.observe(scope === document ? document.body : scope, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'value', 'checked', 'aria-checked']
      });
    }

    function updateBundleForVariant(newVariant) {
      if (!newVariant || !newVariant.id) {
        log('Variant update called with invalid variant', newVariant);
        return;
      }

      log('Updating bundle prices/images for variant', newVariant.id);

      bundleGroup.forEach(function(radio) {
        var variantIds = (radio.getAttribute('data-variant-ids') || '').split(',');
        variantIds[0] = newVariant.id;
        radio.setAttribute('data-variant-ids', variantIds.join(','));
      });

      var origPrice = newVariant.price;
      var origCompare = newVariant.compare_at_price > 0 ? newVariant.compare_at_price : newVariant.price;

      container.querySelectorAll('.fnd-bundle-upsell__option').forEach(function(option) {
        var radio = option.querySelector('.fnd-bundle-upsell__input');
        if (!radio) {
          return;
        }

        var optValue = parseInt(radio.value, 10);
        var optTotal;
        var optCompare;
        var optSave;

        if (optValue === 1 || optValue === 2) {
          var upsellPrice = parseInt(radio.getAttribute('data-upsell-price'), 10);
          var upsellCompare = parseInt(radio.getAttribute('data-upsell-compare'), 10);
          var discount = parseInt(radio.getAttribute('data-discount'), 10);

          var discAmt = Math.ceil(upsellPrice * discount / 100);
          var discountedUpsellPrice = Math.ceil((upsellPrice - discAmt) / 100) * 100;
          optTotal = Math.ceil(origPrice + discountedUpsellPrice);
          optCompare = origCompare + upsellCompare;
          optSave = optCompare - optTotal;
        } else if (optValue === 3) {
          var upsell1Price = parseInt(radio.getAttribute('data-upsell1-price'), 10);
          var upsell1Compare = parseInt(radio.getAttribute('data-upsell1-compare'), 10);

          var upsell2Price = parseInt(radio.getAttribute('data-upsell2-price'), 10);
          var upsell2Compare = parseInt(radio.getAttribute('data-upsell2-compare'), 10);
          var combinedDiscount = parseInt(radio.getAttribute('data-discount'), 10);

          var discAmt1 = Math.ceil(upsell1Price * combinedDiscount / 100);
          var discountedUpsell1Price = Math.ceil((upsell1Price - discAmt1) / 100) * 100;

          var discAmt2 = Math.ceil(upsell2Price * combinedDiscount / 100);
          var discountedUpsell2Price = Math.ceil((upsell2Price - discAmt2) / 100) * 100;

          optTotal = Math.ceil(origPrice + discountedUpsell1Price + discountedUpsell2Price);
          optCompare = origCompare + upsell1Compare + upsell2Compare;
          optSave = optCompare - optTotal;
        } else {
          return;
        }

        var totalPriceElem = option.querySelector('.fnd-bundle-upsell__total-price');
        if (totalPriceElem) {
          totalPriceElem.textContent = formatMoney(optTotal, moneyFormat);
        }

        var comparePriceElem = option.querySelector('.fnd-bundle-upsell__total-compare');
        if (comparePriceElem) {
          comparePriceElem.textContent = formatMoney(optCompare, moneyFormat);
        }

        var saveElem = option.querySelector('.fnd-bundle-upsell__save');
        if (saveElem) {
          saveElem.innerHTML = saveElem.innerHTML.replace(/Save .*!/, 'Save ' + formatMoney(optSave, moneyFormat) + '!');
        }

        var origCard = option.querySelector('.fnd-bundle-upsell__card:first-child');
        if (origCard) {
          var origImg = origCard.querySelector('.fnd-bundle-upsell__card-img');
          if (origImg && newVariant.featured_image && newVariant.featured_image.src) {
            origImg.src = newVariant.featured_image.src.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_80x.$1');
          }

          var origPriceElem = origCard.querySelector('.fnd-bundle-upsell__card-price');
          if (origPriceElem) {
            origPriceElem.textContent = formatMoney(origPrice, moneyFormat);
          }

          var origCompareElem = origCard.querySelector('.fnd-bundle-upsell__card-compare');
          if (origCompareElem) {
            if (origCompare > origPrice) {
              origCompareElem.textContent = formatMoney(origCompare, moneyFormat);
              origCompareElem.style.display = '';
            } else {
              origCompareElem.style.display = 'none';
            }
          }
        }
      });
    }

    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        log('Received variant:change event', event.detail.variant.id);
        updateBundleForVariant(event.detail.variant);
      }
    });

    document.addEventListener('variantChange', function(event) {
      if (event.detail && event.detail.variant) {
        log('Received variantChange event', event.detail.variant.id);
        updateBundleForVariant(event.detail.variant);
      }
    });

    var variantSelect = null;
    if (productForm) {
      variantSelect = productForm.querySelector('.product-select, [name="id"]');
    }
    if (!variantSelect) {
      variantSelect = scope.querySelector('.product-select, [name="id"]');
    }
    if (variantSelect && productHandle) {
      variantSelect.addEventListener('change', function() {
        var variantId = this.value;
        log('Variant select changed to', variantId, 'fetching product JSON');

        fetch('/products/' + productHandle + '.js')
          .then(function(response) {
            return response.json();
          })
          .then(function(productData) {
            var variant = productData.variants.find(function(v) {
              return String(v.id) === String(variantId);
            });

            if (variant) {
              updateBundleForVariant(variant);
            } else {
              log('Variant not found in product JSON for id', variantId);
            }
          })
          .catch(function(error) {
            log('Failed to fetch product JSON for variant update', error);
            return null;
          });
      });
    } else {
      log('No variant select found or missing product handle', {
        hasVariantSelect: !!variantSelect,
        productHandle: productHandle
      });
    }

    if (typeof jQuery !== 'undefined') {
      jQuery(document).on('shopify:variant:change', function(event, variant) {
        if (variant) {
          log('Received jQuery shopify:variant:change', variant.id);
          updateBundleForVariant(variant);
        }
      });
    }
  }

  function initAllBundleUpsells() {
    var containers = document.querySelectorAll('.fnd-bundle-upsell');
    log('Scanning for bundle containers, found', containers.length);
    containers.forEach(initBundleUpsell);
  }

  function observeBundleUpsells() {
    if (typeof MutationObserver === 'undefined') {
      log('MutationObserver not available, dynamic init disabled');
      return;
    }

    log('Starting MutationObserver for dynamic bundle containers');

    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (!node || node.nodeType !== 1) {
            return;
          }

          if (node.matches && node.matches('.fnd-bundle-upsell')) {
            log('Observed direct bundle container insertion');
            initBundleUpsell(node);
          }

          if (node.querySelectorAll) {
            var nested = node.querySelectorAll('.fnd-bundle-upsell');
            if (nested.length) {
              log('Observed nested bundle container insertion count', nested.length);
            }
            nested.forEach(initBundleUpsell);
          }
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initAllBundleUpsells();
      observeBundleUpsells();
    });
  } else {
    initAllBundleUpsells();
    observeBundleUpsells();
  }
})();
